import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import translationEN from './locales/en/translation.json';
import translationBRPT from './locales/br/translation.json';
import translationES from './locales/es/translation.json';
const resources = {
  en: {
    translation: translationEN,
  },
  br: {
    translation: translationBRPT,
  },
  es: {
    translation: translationES,
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: 'br',

  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
